

export const edgeExists = (newEdge, edges) => {
  return edges.find(edge => edge.from === newEdge.from && edge.to === newEdge.to) !== undefined;
};
